import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useOutsideClick, sendTrackingInfo } from '@panel/commons';
import Cookies from 'js-cookie';
import Switch from '@panel/commons/lib/Switch';
import { GeneralCheckDropdown, DropdownButton, DropDownCheckList, DropdownOption } from './styles';
import { FilterOperations, FilterSelectors } from '../../../../ducks/filter';
import { getTranslationByKey } from '../../../../helpers/datalayerTranslate';
import useUrlSearchParams from '../../hooks/useUrlSearchParams';

const SortMenu = ({ device }) => {
  const { t } = useTranslation();
  const hasSortOnlineFirstCookie = Cookies.get('SortOnlineFirst');
  const sortOnlineFirstCookie = Cookies.get('SortOnlineFirst') && JSON.parse(Cookies.get('SortOnlineFirst'));
  const [dropDownState, setDropDownState] = useState(false);
  const [activeSortOnlineFirst, setActiveSortOnlineFirst] = useState(
    hasSortOnlineFirstCookie ? sortOnlineFirstCookie : true
  );
  const sortRef = useRef();
  const dispatch = useDispatch();
  const { appliedFilters } = useSelector(FilterSelectors.getFiltersState);
  const { setUrlSearch } = useUrlSearchParams();

  useOutsideClick(sortRef, () => {
    if (dropDownState) {
      setDropDownState(false);
    }
  });

  const sortCriteriaList = [
    'modifiedNewer',
    'modifiedOlder',
    'createdNewer',
    'createdOlder',
    'lowerPrice',
    'higherPrice',
    'lowerQuality',
    'higherQuality'
  ];

  const handleSortOnlineFirst = () => {
    setActiveSortOnlineFirst(!activeSortOnlineFirst);
    dispatch(FilterOperations.update({ onlineFirst: !activeSortOnlineFirst }));
    // se crea cookie para mantener los filtros aplicados al recargar el navegador. En éste caso estamos seteando el value del filtro en la cookie, por lo tanto no necesitamos añadir la query a la url con la función setUrlSearch()
    Cookies.set('SortOnlineFirst', !activeSortOnlineFirst, { expires: 999 });
    setDropDownState(false);
  };

  return (
    <GeneralCheckDropdown
      device={device}
      width={device === 'tablet' ? 230 : 240}
      ref={sortRef}
      active={dropDownState}
      onClick={() => setDropDownState(!dropDownState)}
    >
      <DropdownButton data-panel='postingsBar-sortMenu-chevron' />
      <span>
        {appliedFilters.sort.id ? t(`panel.bar.select.sort.${appliedFilters.sort.id}`) : t('panel.bar.sortBy')}
      </span>
      <DropDownCheckList device={device} size='238px' smallPadding>
        {sortCriteriaList.map(criteria => (
          <DropdownOption
            data-panel={`postingsBar-sortMenu-option-${criteria}`}
            key={criteria}
            className={appliedFilters.sort.id && appliedFilters.sort.id === criteria && 'SEARCHBAR-DROP-SELECTED'}
            onClick={() => {
              sendTrackingInfo('Panel', 'Mis avisos', `Ordenamiento-${getTranslationByKey(criteria)}`);
              dispatch(FilterOperations.update({ sort: { id: criteria, displayName: criteria } }));
              // seteamos el filtro en la url para mantener los filtros aplicados al recargar el navegador:
              setUrlSearch(criteria, 'sort');
            }}
          >
            {t(`panel.bar.select.sort.${criteria}`)}
          </DropdownOption>
        ))}
        <div className='separator' />
        <div className='sortOnlineFirst' data-panel='postingsBar-sortMenu-onlineFirst'>
          <span>{t(`panel.bar.select.sort.onlineFirst`)}</span>
          <Switch
            id='sortOnlineFisrt'
            toggled={activeSortOnlineFirst}
            onChange={() => handleSortOnlineFirst()}
            dataPanel='sortOnlineFisrt'
          />
        </div>
      </DropDownCheckList>
    </GeneralCheckDropdown>
  );
};

export default SortMenu;
